import { __assign } from "tslib";
import { csrf } from './headers/csrf';
import { xWixBrand } from './headers/x-wix-brand';
import { consentPolicy } from './headers/consent-policy';
import { authorization } from './headers/authorization';
import { artifactId } from './headers/artifact-id';
import { commonConfig } from './headers/common-config';
import { linguistHeader } from './headers/linguist';
import { assertBoolean, assertString } from './assert';
export function createHeaders(opts) {
    if (opts === void 0) { opts = {}; }
    opts = __assign({ csrf: true, signedInstance: '' }, opts);
    verifyOptsOrThrow(opts);
    var headers = [
        xWixBrand(),
        consentPolicy(),
        authorization(opts.signedInstance),
        artifactId(opts.artifactId),
        commonConfig(),
        linguistHeader(__assign({ signedInstance: opts.signedInstance }, opts.multilingualOptions)),
    ];
    if (opts.csrf) {
        headers.push(csrf());
    }
    return headers
        .filter(function (hdrs) { return Object.values(hdrs).every(function (v) { return v; }); })
        .reduce(function (result, hdrs) { return (__assign(__assign({}, result), hdrs)); }, {});
}
function verifyOptsOrThrow(opts) {
    assertBoolean('opts.csrf', opts.csrf);
    assertString('opts.signedInstance', opts.signedInstance);
}
//# sourceMappingURL=index.js.map